<template>
  <div class="tool">
    <ul>
      <el-popover
        placement="left-start"
        title=""
        width="150"
        trigger="hover">
        <li slot="reference">
          <img :src="iconPublic" />
          <p>公众号</p>
        </li>
        <div class="index-tool-ewm">
          <img :src="qrPublic" />
          <p>
            扫描二维码关注
            <br />
            湖南省志愿服务网
            <br />
            微信公众号
          </p>
        </div>
      </el-popover>
      <el-popover
        placement="left-start"
        title=""
        width="218"
        trigger="hover">
        <li slot="reference">
          <img :src="iconService" />
          <p>在线客服</p>
        </li>
        <div class="index-tool-ewm">
          <img
            style="width: 200px; height: auto"
            :src="qrWorkQq" />
        </div>
      </el-popover>

      <el-popover
        placement="left-start"
        title=""
        width="218"
        trigger="hover">
        <li slot="reference">
          <img :src="iconPublic" />
          <p>微信沟通</p>
        </li>
        <div class="index-tool-ewm">
          <img
            style="width: 200px; height: auto"
            :src="qrWorkWeixin" />
          <p>
            扫描二维码关注
            <br />
            湖南省志愿服务网
            <br />
            微信沟通社群
          </p>
        </div>
      </el-popover>
      <!-- <li>
        <router-link :to="{ path: '/help' }">
          <img :src="iconTutorial" />
          <p>新手教程</p>
        </router-link>
      </li> -->
      <el-popover
        placement="left-start"
        title=""
        width="218"
        trigger="hover">
        <li slot="reference">
          <img :src="iconComplaint" />
          <p>建议信箱</p>
        </li>
        <div class="index-tool-ewm">
          <img
            style="width: 200px; height: auto"
            :src="qrComplaintMail" />
          <p>
            建议信箱
            <br />
            hnswzsc@126.com
          </p>
        </div>
      </el-popover>
    </ul>
  </div>
</template>
<script>
// 右侧悬浮工具栏图标与二维码，改为本地打包资源
// 原来引用的 https://hnvs.cn/template/... 为旧 PHP 站点（裸域名）资源，
// 该服务已不可访问，导致本地开发环境图片裂开；线上构建使用的是本地资源。
import iconPublic from '@/assets/tool/index-tool-2.png';
import iconService from '@/assets/tool/index-tool-3.png';
import iconTutorial from '@/assets/tool/index-tool-4.png';
import iconComplaint from '@/assets/tool/tousu_1.png';
import qrPublic from '@/assets/tool/index-ewm.png';
import qrWorkQq from '@/assets/tool/work-weixin-qq.png';
import qrWorkWeixin from '@/assets/tool/work-weixin.jpg';
import qrComplaintMail from '@/assets/tool/tousu-mail.png';
export default {
  name: 'PageTool',
  data() {
    return {
      iconPublic,
      iconService,
      iconTutorial,
      iconComplaint,
      qrPublic,
      qrWorkQq,
      qrWorkWeixin,
      qrComplaintMail,
    };
  },
};
</script>
<style lang="scss" scoped>
.tool {
  position: fixed;
  z-index: 100;
  right: 10px;
  top: 200px;
  height: auto;
  width: 60px;
}
.tool li {
  width: 100%;
  height: 60px;
  margin-bottom: 1px;
  background: #eb001b;
  list-style: none;
  cursor: pointer;
  font-size: 12px;
  text-align: center;

  position: relative;
}
.tool p {
  color: #fff;
}
.index-tool-ewm {
  text-align: center;
}
.tool li img {
  margin-top: 10px;
}

.tool li:hover {
  background: #aa0101;
}
</style>
